import axios from 'axios'
import interceptors from './interceptors'

let API_BASE_URL
// for testing purposes
API_BASE_URL = process.env.API_HOST || 'http://localhost:8081/'

export const paramsToString = (p) => p.toString() !== '' ? `?${p.toString()}` : p.toString()

class HttpClient {
  constructor () {
    this.client = axios.create({ baseURL: API_BASE_URL })
    interceptors.createRequestInterceptor(this)
    interceptors.createResponseInterceptor(this)
  }

  request (method, url, data, config) {
    return new Promise((resolve, reject) => {
      this.client[method](url, data, config || {})
        .then(response => {
          resolve(response.data)
        }).catch(error => {
          if (error?.response?.status === 401) {
            window.location.href = '/logout'
          } else {
            reject(error)
          }
        })
    })
  }

  get (url, data, config) {
    return this.request('get', url, data, config)
  }

  post (url, config) {
    return this.request('post', url, config)
  }

  put (url, config) {
    return this.request('put', url, config)
  }

  patch (url, config) {
    return this.request('patch', url, config)
  }

  delete (url, config) {
    return this.request('delete', url, config)
  }

  addHeader (header, method = null) {
    if (!method) {
      this.client.defaults.headers.common[header.name] = header.value
      return
    }
    this.client.defaults.headers[method.toLowerCase()][header.name] = header.value
  }

  getHeader (headerName) {
    return this.client.defaults.headers.common[headerName]
  }
}

const httpClient = new HttpClient()

export default httpClient
